import(/* webpackMode: "eager" */ "/app/src/app/admin/layout.tsx");
